import { render, staticRenderFns } from "./card2.vue?vue&type=template&id=c9254f92&scoped=true&"
import script from "./card2.vue?vue&type=script&lang=js&"
export * from "./card2.vue?vue&type=script&lang=js&"
import style0 from "./card2.vue?vue&type=style&index=0&id=c9254f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9254f92",
  null
  
)

export default component.exports